import axios from "axios";
import { getPathAPI, getAuthHeaders, triggerBlobDownload } from "@/helpers";

/**
 * Downloads a file securely by sending the access token in the
 * Authorization header instead of as a URL query parameter.
 *
 * This prevents token leakage through browser history, server logs,
 * referrer headers, and proxy logs.
 */
export async function secureFileDownload(
  fileId: string,
  fileName?: string
): Promise<void> {
  const response = await axios({
    url: `${getPathAPI()}/file/view/${fileId}`,
    method: "GET",
    responseType: "blob",
    headers: getAuthHeaders()
  });

  triggerBlobDownload(response.data, fileName || "", { target: "_blank" });
}

/**
 * Returns a one-time blob URL for a file, fetched with a secure
 * Authorization header. Use this when you need the URL for an
 * <img src> or similar, rather than triggering a download.
 */
export async function secureFileUrl(fileId: string): Promise<string> {
  const response = await axios({
    url: `${getPathAPI()}/file/view/${fileId}`,
    method: "GET",
    responseType: "blob",
    headers: getAuthHeaders()
  });

  return window.URL.createObjectURL(new Blob([response.data]));
}
